import React from 'react';
import { BODY } from '../../primitives.js';

const h = React.createElement;

let warmUntil = 0;

/**
 * Label for a control: hover (400ms, then instant), keyboard focus (instant), Esc closes.
 *
 * @param {object} p
 * @param {React.ReactNode} p.label
 * @param {React.ReactElement} p.children
 * @param {'top'|'bottom'} [p.side]
 * @param {number} [p.delay]
 */
export function Tooltip({ label, children, side = 'top', delay = 400 }) {
  const [pos, setPos] = React.useState(null);
  const ref = React.useRef(null), timer = React.useRef(0);
  const id = React.useMemo(() => 'gx-tip-' + Math.random().toString(36).slice(2, 8), []);
  const show = (now) => { clearTimeout(timer.current); const go = () => { const el = ref.current; if (!el) return; const r = el.getBoundingClientRect(); setPos({ x: r.left + r.width / 2, y: side === 'top' ? r.top - 8 : r.bottom + 8 }); }; if (now || Date.now() < warmUntil) go(); else timer.current = setTimeout(go, delay); };
  const hide = () => { clearTimeout(timer.current); if (pos) warmUntil = Date.now() + 600; setPos(null); };
  React.useEffect(() => { if (!pos) return; const k = (e) => e.key === 'Escape' && hide(); const s = () => hide(); window.addEventListener('keydown', k); window.addEventListener('scroll', s, true); return () => { window.removeEventListener('keydown', k); window.removeEventListener('scroll', s, true); }; }, [pos]);
  if (!label) return children;
  return h(React.Fragment, null,
    h('span', { ref, 'aria-describedby': pos ? id : undefined, onPointerEnter: () => show(false), onPointerLeave: hide, onFocus: () => show(true), onBlur: hide, style: { display: 'inline-flex' } }, children),
    pos ? h('span', { id, role: 'tooltip', style: { position: 'fixed', left: pos.x, top: pos.y, transform: side === 'top' ? 'translate(-50%, -100%)' : 'translate(-50%, 0)', zIndex: 90, maxWidth: 260, padding: '5px 9px', background: 'var(--inkbg)', color: 'var(--oninkbg)', border: '1.5px solid var(--ink)', borderRadius: 8, fontFamily: BODY, fontSize: 11.5, fontWeight: 700, lineHeight: 1.35, pointerEvents: 'none', whiteSpace: 'normal', width: 'max-content' } }, label) : null);
}
